import { Command } from 'commands/Commands';

export class AddFeaturedArticles extends Command {
  type: string = 'SetFeaturedArticles';
  constructor(public id: string, newValue: string | null) {
    super(newValue, id);
  }
  priority: number = 100;
}
